import React from "react";
import { experience } from "../data/content";

export default function Experience() {
  return (
    <section
      id="experience"
      className="section-pad border-t border-rule bg-graphite text-inverse"
    >
      <div className="wrap">
        <header className="reveal mb-12 max-w-3xl">
          <p className="label text-inverse-muted">04 / Experience</p>
          <h2 className="mt-4 font-display text-[clamp(1.75rem,3vw,2.5rem)] font-semibold tracking-[-0.02em] text-inverse">
            Technical progression
          </h2>
          <p className="mt-4 text-inverse-muted">
            Support → software engineering → ETL / data → hosting &
            infrastructure → website security → product engineering & applied AI.
            One path through how systems fail and how they get fixed.
          </p>
        </header>

        <ol className="space-y-0">
          {experience.map((job, index) => (
            <li
              key={job.id}
              className="reveal grid gap-6 border-t border-inverse/15 py-8 lg:grid-cols-12"
            >
              <div className="lg:col-span-4">
                <p className="font-mono text-[0.6875rem] uppercase tracking-[0.06em] text-accent">
                  {String(index + 1).padStart(2, "0")}
                </p>
                <h3 className="mt-2 font-display text-xl font-semibold text-inverse">
                  {job.company}
                </h3>
                {job.location ? (
                  <p className="mt-1 text-sm text-inverse-muted">{job.location}</p>
                ) : null}
              </div>

              <div className="lg:col-span-8">
                <ul className="space-y-2">
                  {job.roles.map((role) => (
                    <li
                      key={role.title + role.period}
                      className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:justify-between"
                    >
                      <span className="text-inverse">{role.title}</span>
                      <span className="font-mono text-[0.75rem] text-inverse-muted">
                        {role.period}
                      </span>
                    </li>
                  ))}
                </ul>

                {job.summary ? (
                  <p className="mt-4 text-sm text-inverse-muted">{job.summary}</p>
                ) : null}

                {job.highlights.length > 0 ? (
                  <ul className="mt-4 space-y-2">
                    {job.highlights.map((item) => (
                      <li
                        key={item.slice(0, 40)}
                        className="flex gap-3 text-sm text-inverse-muted"
                      >
                        <span aria-hidden="true" className="mt-2 h-px w-4 shrink-0 bg-accent" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
